// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loading_spinner__FIGkD"};